import { MapItem } from './map-item.interface';

export interface ApiListResult {
  data: MapItem[];
}
